import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';
import { Observable } from 'rxjs';
import { Source } from '@referrals/shared/models';

@Injectable({
  providedIn: 'root',
})
export class SourceService {
  private headers: HttpHeaders;
  private accessPointUrl: string;

  constructor(private config: ConfigService, private http: HttpClient) {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
    });
    this.accessPointUrl = `${this.config.referralsApiUrl}/sources`;
  }

  public get(): Observable<Source[]> {
    return this.http.get<Source[]>(this.accessPointUrl, {
      headers: this.headers,
    });
  }

  public getById(id: number): Observable<Source[]> {
    return this.http.get<Source[]>(this.accessPointUrl + '/' + id, {
      headers: this.headers,
    });
  }

  public add(payload): Observable<Source> {
    return this.http.post<Source>(this.accessPointUrl, payload, {
      headers: this.headers,
    });
  }

  public update(payload): Observable<Source> {
    return this.http.put<Source>(
      this.accessPointUrl + '/' + payload.id,
      payload,
      {
        headers: this.headers,
      }
    );
  }

  public delete(id: number): Observable<any> {
    return this.http.delete(this.accessPointUrl + '/' + id, {
      headers: this.headers,
    });
  }
}
